export const FORM_STEP = 'form';
export const FAILURE_STEP = 'failure';
export const SUCCESS_STEP = 'success';

export const IDENTITY_VERIFICATION_STEPS = [
    FORM_STEP,
    FAILURE_STEP,
    SUCCESS_STEP,
];
